import React from "react";
import { Button } from "@chakra-ui/react";
import { Pencil } from "lucide-react";

type EditButtonProps = {
  onClick: () => void;
};

/** Small outline "Edit" button used in every InfoCard section header. */
const EditButton: React.FC<EditButtonProps> = ({ onClick }) => (
  <Button
    onClick={onClick}
    leftIcon={<Pencil size={16} />}
    variant="outline"
    size="sm"
    borderRadius="12px"
    borderColor="#E9DFDF"
    color="#4A2C2A"
    _hover={{ bg: "#FAF7F7" }}
  >
    Edit
  </Button>
);

export default EditButton;
